import React from 'react';
import { FileText } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';

export const CancellationPolicy = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <div className="pb-8">
      <h2 className="text-2xl font-semibold mb-4 text-gray-900 flex items-center gap-2">
        <FileText className="h-6 w-6" />
        {t.cancellationTitle}
      </h2>
      
      <p className="text-gray-700 whitespace-pre-line leading-relaxed mb-4">
        {t.cancellationPolicy}
      </p>
    </div>
  );
};
